module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"none":"No news found"},"it":{"none":""},"lt":{"none":"Nerasta jokių naujienų"},"pl":{"none":"Brak nowych wiadomości"}}')
  delete Component.options._Ctor
}
